






























































































































import {
  computed, defineComponent, Ref, ref, watch,
} from 'vue';

import store from '@/store';

import WorkspaceDialog from '@/components/WorkspaceDialog.vue';
import DeleteWorkspaceDialog from '@/components/DeleteWorkspaceDialog.vue';
import AboutDialog from '@/components/AboutDialog.vue';
import { LoginMenu } from 'multinet-components';
import { CheckboxTable } from '@/types';
import { useCurrentInstance } from '@/utils/use';
import oauthClient from '@/oauth';

export default defineComponent({
  components: {
    DeleteWorkspaceDialog,
    WorkspaceDialog,
    AboutDialog,
    LoginMenu,
  },

  setup() {
    const newWorkspace = ref('');
    const checkbox: Ref<CheckboxTable> = ref({});
    const loading = ref(true);
    const singleSelected: Ref<string | null> = ref(null);
    const tabSelected = ref(1);

    const workspaces = computed(() => store.state.workspaces);
    const userInfo = computed(() => store.state.userInfo);
    const somethingChecked = computed(() => Object.values(checkbox.value).some(Boolean));
    const checked = computed(() => Object.keys(checkbox.value).filter((d) => !!checkbox.value[d]));
    const currentInstance = useCurrentInstance();
    const navHeight = computed(() => (currentInstance.proxy.$vuetify.breakpoint.height - 62));
    const selection = computed(() => (singleSelected.value ? [singleSelected.value] : checked.value));

    watch(userInfo, (newUserInfo) => {
      if (newUserInfo !== null) {
        tabSelected.value = 0;
      } else {
        tabSelected.value = 1;
      }
    });

    store.dispatch.fetchWorkspaces().then(() => { loading.value = false; });

    const router = currentInstance.proxy.$router;
    function route(workspace: string) {
      if (router !== null) {
        router.push(`/workspaces/${workspace}`);
      }
    }

    function workspaceDeleted() {
      checkbox.value = {};
      if (router !== null) {
        router.replace({ name: 'home' });
      }
    }

    const dws = ref(null);
    function deleteWorkspace(ws: string) {
      singleSelected.value = ws;

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (dws as any).dialog = true;
    }

    return {
      newWorkspace,
      checkbox,
      loading,
      singleSelected,
      tabSelected,
      workspaces,
      somethingChecked,
      navHeight,
      selection,
      userInfo,
      route,
      workspaceDeleted,
      deleteWorkspace,
      oauthClient,
      store,
    };
  },
});
